export const defaultBindings = {
  service: 'ria-client',
};
